import createApp from '@infotech/4sides-front-core'
import agreementModuleExtension, { AgreementTasksUpdater } from '@infotech/agreement'
import { addDictRequestActions } from '@infotech/4sides-core-dictionaries'
import mapissuesConfig from './mapissuesConfig'
import administratorConfig from './administratorConfig'
import serverNotificationsConfig from './notificationsConfig'
import reportsConfig from './reportsConfig'
import pageConfig from './pageConfig'
import getHeaderConfig from './headerConfig'
import { REACT_APP_DOCUMENT_TITLE } from './api/constants'
import DocumentLogoComponent from './components/DocumentLogo'
import eszDictionariesActions from './dictionaries'

import './style.css'

document.title = REACT_APP_DOCUMENT_TITLE

addDictRequestActions(eszDictionariesActions)

createApp({
  DocumentLogoComponent,
  extensions: [
    agreementModuleExtension,
    reportsConfig,
  ],
  initialStoreState: {
    documentTitle: {
      brand          : REACT_APP_DOCUMENT_TITLE,
      route          : null,
      activeModalForm: null,
    },
  },
  headerConfig                : getHeaderConfig(),
  customMiddlewares           : [AgreementTasksUpdater],
  mapissuesModuleExtension    : mapissuesConfig,
  administratorModuleExtension: administratorConfig,
  serverNotificationsConfig,
  pageConfig,
  customReducers              : {},
  customSagas                 : [],
})
